// output: x.y.z
import zip from 'lodash/zip';

import { tauriInvoke } from './desktopIntegration';

const parseVersion = (v: string) => v.split('-')[0].split('.').map(Number);

export const getCurrentDesktopVersion = async (): Promise<string> => (await tauriInvoke('get_version')) as string;

export const isDesktopVersionLowerOrEqual = async (targetVersion: string): Promise<boolean> => {
  const current = parseVersion(await getCurrentDesktopVersion());
  const target = parseVersion(targetVersion);

  for (const [c, t] of zip(current, target)) {
    if ((c || 0) < (t || 0)) return true;
    if ((c || 0) > (t || 0)) return false;
  }
  return true;
};

export const isDesktopVersionLowerThan = async (targetVersion: string): Promise<boolean> => {
  const current = parseVersion(await getCurrentDesktopVersion());
  const target = parseVersion(targetVersion);

  for (const [c, t] of zip(current, target)) {
    if ((c || 0) < (t || 0)) return true;
    if ((c || 0) > (t || 0)) return false;
  }
  return false;
};
